import { forwardRef } from 'react'
import { NumericFormat, NumericFormatProps } from 'react-number-format'

import { Input } from '@/components/ui/input'

interface CustomNumberInputProps extends Omit<NumericFormatProps, 'getInputRef'> {
  onValueChange: (values: { floatValue: number | undefined; value: string }) => void
}

export const CustomNumberInput = forwardRef<HTMLInputElement, CustomNumberInputProps>(
  function CustomNumberInput({ onValueChange, ...rest }, ref) {
    return (
      <NumericFormat
        getInputRef={ref}
        customInput={Input}
        decimalSeparator=","
        thousandSeparator=" "
        onValueChange={onValueChange}
        {...rest}
      />
    )
  },
)
